/* eslint-disable no-unused-vars */
export enum Theme {
  Wine = 'wine',
  Beer = 'beer',
  Ethanol = 'ethanol',
}
